/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { ExtensibleNode } from '../ExtensibleNode';

/**
 * Base class for components defined by AsyncAPI 2+ and OpenAPI 3+.
 * @author eric.wittmann@gmail.com
 * @class
 * @extends ExtensibleNode
 */
export abstract class Components extends ExtensibleNode {
    constructor() {
        super();
    }
}
Components["__class"] = "io.apicurio.datamodels.core.models.common.Components";
Components["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable"];




